import Typography from '@material-ui/core/Typography';

import { Container, StyledTypography } from './styled';

/*
 * This component is displayed in case it is not possible to communicate with the server
 */

const ServerErrorMessage = () => {
    return (
        <Container>
            <Typography variant='h2'>
                Plastic Free Certification
            </Typography>
            <StyledTypography variant='h5'>
                Cannot reach the server. Please try again later.
            </StyledTypography>
        </Container>
    );
};

export default ServerErrorMessage;
